import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Layers, X } from 'lucide-react';

export default function PooledJobFloatingBar({
  selectedProcesses,
  onOpenPooledJobDialog,
  canCreatePooledJob,
  getSelectedProcessName,
  onClearSelection,
}) {
  const entries = Object.values(selectedProcesses);
  if (entries.length === 0) return null;

  const totalQty = entries.reduce((s, p) => s + (p.pending_qty || 0), 0);
  const processName = getSelectedProcessName();
  const allSameProcess = entries.every(p => p.process_name === processName);

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="flex items-center gap-4 bg-purple-950 text-white rounded-full pl-5 pr-3 py-2.5 shadow-2xl border border-purple-800">
        <Layers className="w-4 h-4 text-purple-300 shrink-0" />
        <div className="flex items-center gap-2 text-sm">
          <span className="font-semibold">{entries.length}</span>
          <span className="text-purple-200">process{entries.length > 1 ? 'es' : ''}</span>
          <Badge className="bg-purple-800 text-purple-100 border-purple-700 text-xs font-medium">{processName}</Badge>
          <span className="text-purple-300">&middot;</span>
          <span className="text-purple-200">{totalQty} units</span>
        </div>
        {!allSameProcess && (
          <span className="text-xs text-red-300">Mixed processes</span>
        )}
        <Button
          size="sm"
          onClick={onOpenPooledJobDialog}
          disabled={!canCreatePooledJob()}
          className="bg-purple-600 hover:bg-purple-500 text-white rounded-full h-8 px-4 text-sm"
          data-testid="floating-create-pooled-btn"
        >
          Create Pooled Job
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={onClearSelection}
          className="text-purple-300 hover:text-white hover:bg-purple-800 rounded-full h-8 w-8 p-0"
          data-testid="floating-clear-pooled-btn"
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
